import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const Container = styled.button(({ theme }) => ({
  width: "100%",
  padding: "1.6rem 2rem",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.semiBold,
  color: "#370f0f",
  backgroundColor: theme.color.yellow,
  lineHeight: "2rem",
}));

const KakaoChatButton = () => {
  const handleClick = () => {
    const url = "http://pf.kakao.com/_vfRpxj";
    window.open(url, "_blank");
  };
  const { t } = useTranslation();

  return (
    <Container onClick={handleClick}>{t("카카오톡 1:1 채팅 문의")}</Container>
  );
};

export default KakaoChatButton;
